<template>
    <div class="flex relative my-auto container mx-auto">

      <div class="subsection-big-circle flex flex-col bg-black rounded-full mx-auto">
        <h1 class="text-white mx-auto pt-20 text-2xl font-bold">PREVIEW</h1>
        <div class="flex flex-col mx-auto mt-8 w-full">
          <div class="flex justify-between px-8">
            <div class="mini-circles flex flex-col bg-yellow-500 rounded-full cursor-pointer" @click="showPdf('pdfUrlOne')">
              <div class="m-auto">
                <h4 class="font-bold text-xl">THE IDEA</h4>
                <p class="font-bold text-sm">(PDF)</p>
              </div>
            </div>
            <div class="mini-circles flex bg-yellow-500 rounded-full cursor-pointer" @click="showPdf('pdfUrlTwo')">
              <div class="m-auto">
                <h4 class="font-bold text-xl">THE RESULT</h4>
                <p class="font-bold text-sm">(PDF)</p>
              </div>
            </div>
          </div>
          <div class="mini-circles flex bg-yellow-500 rounded-full cursor-pointer mx-auto" @click="showPdf('pdfUrlThree')">
            <div class="m-auto">
              <h4 class="font-bold text-xl">THE WAY</h4>
              <p class="font-bold text-sm">(PDF)</p>
            </div>
          </div>
        </div>
      </div>

      <NextArrow next="sub-general-two"/>

    </div>
</template>

<script>
import NextArrow from "@/components/deepinfo/subnavigation/NextArrow.vue";

export default {
  name: "GeneralSubOne",
  props:{
    pdfUrlOne:{
      required: true,
      type: String,
    },
    pdfUrlTwo:{
      required: true,
      type: String,
    },
    pdfUrlThree:{
      required: true,
      type: String,
    }
  },
  components:{
    NextArrow
  },
  methods:{
    showPdf(prop){
      window.open(this[prop]);
    }
  }
}
</script>

<style lang="css" scoped>
  .mini-circles{
    width: 10rem;
    height: 10rem;
    background-color: #f6faa0;
    color: #fa4141;
  }
</style>
